module.exports = __webpack_public_path__ + "static/media/search_result.e83d445e.svg";